<template>
  <v-container>
    <v-card color="primary" class="rounded-xxl py-16 px-10">
      <div class="d-flex align-center justify-space-between textColor rounded-lg px-4 py-2">
        <p class="sm-font300-14 primary--text mb-0">تعریف دوره مستقل</p>
        <v-icon>mdi-chevron-left</v-icon>
      </div>
      <div class="textColor px-6 py-8 rounded-lg mt-3">
        <v-stepper v-model="courseStep" alt-labels elevation="0">
          <v-stepper-header>
            <v-stepper-step
                :complete="courseStep === 1"
                step=""
                complete-icon=""
                @click="courseStep = 1"
            >
              اطلاعات دوره
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                :complete="courseStep === 2"
                step=""
                complete-icon=""
                @click="courseStep = 2"
            >
              برنامه
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                :complete="courseStep === 3"
                step=""
                complete-icon=""
                @click="courseStep = 3"
            >
              حرکت
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <infos :formType="'edit'" :contentData="stepData" v-if="!loading" @nextStep="nextStep"/>
            </v-stepper-content>

            <v-stepper-content step="2">
              <plans v-if="courseStep === 2" @nextStep="nextStep"/>
            </v-stepper-content>

            <v-stepper-content step="3">
              <actions  v-if="courseStep === 3"/>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </div>

    </v-card>
  </v-container>
</template>
<script>
import infos from "@/components/Courses/Classes/independentClass/infos.vue"
import plans from "@/components/Courses/Classes/independentClass/plans.vue"
import actions from "@/components/Courses/Classes/independentClass/actions.vue"
import courseApi from "@/Services/modules/courses";

export default {
  name: "editIndependent",
  components: {infos, actions, plans},
  data() {
    return{
      courseStep: Number(this.$route.query.tab) || 1,
      stepData: {
        course_type: "Online_Offline"
      },
      loading: false
    }
  },
  methods: {
    nextStep(val) {
      this.courseStep = val
    },
    async getData() {
      this.loading = true
      await courseApi.getClassById(this.$route.params.id).then(res => {
        this.stepData = res.data
        this.loading = false
      })
    },
  },
  mounted() {
    this.getData()
  }
}
</script>
<style scoped>

</style>
